module.exports = __webpack_public_path__ + "media/images/plus-f52f2f30a07d6b041ced0381242a9973.png";